import DataVariableInterface from "../../DataVariables/ts/DataVariableInterface";
import Condition from "./Condition";
import Query from "./Query";

export default class ExcludedQuotaBucketFinder {

    private readonly result: Array<Object>;

    /**
     * Equal Divider
     *
     * @param query
     * @param dataVariables
     */
    constructor(query: Query, dataVariables: Array<DataVariableInterface>) {

        this.result = [];

        if (query.booleanOperation === "must") {

            query.conditions.forEach((condition: Condition) => {

                const variable = dataVariables.find((variable: DataVariableInterface) => condition.dataVariableId === variable.uuid);

                if (variable) {
                    this.parseRadio(variable, condition);
                    this.parseDate(variable, condition);
                } else {
                    console.error("ExcludeQuotaBucketFinder: Variable ID: (" + condition.dataVariableId + ") not found!");
                }
            });
        }
    }

    /**
     * Parse unique IDs that are excluded in the query
     *
     * @param variable
     * @param condition
     * @protected
     */

    protected parseRadio(variable: DataVariableInterface, condition: Condition) {
        if (variable.type === "radio" && variable.options && condition.operation === "terms") {

            const uniqueIds = condition.value;

            const variableUniqueIds = variable.options.map(option => option.unique_id);

            const diff = this.arrayDiff(variableUniqueIds, uniqueIds);

            this.result.push({
                variable: variable,
                uniqueIds: diff
            })
        }
    }

    /**
     * Parse range IDs that are excluded in the query
     *
     * @param variable
     * @param condition
     * @protected
     */
    protected parseDate(variable: DataVariableInterface, condition: Condition) {
        if (variable.type === "date" && variable.ranges && condition.operation === "age") {

            const rangeIds = condition.value;

            const variableRangeIds = variable.ranges.map(range => range.id);

            const diff = this.arrayDiff(variableRangeIds, rangeIds);

            if (diff && diff.length > 0) {
                this.result.push({
                    variable: variable,
                    rangeIds: diff
                })
            }
        }
    }

    /**
     * Find different in the arrays
     *
     * @param arr1
     * @param arr2
     * @protected
     */
    protected arrayDiff(arr1: Array<number | string>, arr2: Array<number | string>) {
        return arr1.filter(x => !arr2.includes(x));
    }

    /**
     * Get results
     */
    public getResults() {
        return this.result;
    }
}

